import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/index';
// moment
import moment, { max } from 'moment';
// vant:
import Vant from 'vant';
import 'vant/lib/index.css';
// my http:
import { post, get, patch, put } from '@/utils/http';

// my font:
import "./assets/myfont/font.css";
// 在线：
// import "./assets/myfont/iconfont.css";
// 本地：
import "./assets/font/iconfont.css";
// 神策埋点SDK
import sensorsPlugin from './extend/plugins/collect_cdp/sensors.js'

Vue.use(Vant);

// 神策插件安装
Vue.use(sensorsPlugin)

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$moment = moment;

let linkURL = '';
let devApiUrl = 'https://newmtest.dominos.com.cn/';
let funApiUrl = 'https://m8-fun.dominos.com.cn/'
let uatApiUrl = 'https://m8-uat.dominos.com.cn/'
let uatApiUrl2 = 'https://m8-uat2.dominos.com.cn/'
let proApiUrl = 'https://m8.dominos.com.cn/'

if (window.location.host.includes("-dev")) {
  linkURL = devApiUrl;
} else if (window.location.host.includes("-fun")) {
  linkURL = funApiUrl;
} else if (window.location.host.includes("-uat2")) {
  linkURL = uatApiUrl2;
} else if (window.location.host.includes("-uat")) {
  linkURL = uatApiUrl;
} else if (window.location.host.includes("luckydraw.dominos.com.cn")) {
  linkURL = proApiUrl;
} else {
  linkURL = devApiUrl;
}
// const linkURL = window.location.host.includes("-fun") ? 'https://m8-fun.dominos.com.cn/' : (process.env.NODE_ENV === "production" ? 'https://m8.dominos.com.cn/' : 'https://m8-fun.dominos.com.cn/');



Vue.prototype.$linkURL = linkURL;
console.log("process.env.NODE_ENV:", process.env.NODE_ENV);

// 兼容PC:如果是PC，会被嵌套进iframe里面 start：
import "@/assets/style/base.scss";
var maxWidth = 375;
var isMobile = /Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent);

const baseStr = window.location.href.includes("?") ? window.location.href.split("?")[1] : '';
let baseUrlPC = "";

if (window.location.href.includes("myGiftAll")) {
  baseUrlPC = `${window.location.href.split("#")[0]}#/myGiftAll?${baseStr}`;
} else {
  baseUrlPC = `${window.location.href.split("#")[0]}#/?${baseStr}`;
}

if (isMobile) {
  maxWidth = document.documentElement.clientWidth;
}
var i = document.documentElement;
if (maxWidth < i.clientWidth && !isMobile) {
  document.querySelector('body').style.display = 'none'; //隐藏原有的页面，用iframe进行替代
  document.querySelector('html').classList.add('pc');
  document.querySelector('html').style.width = maxWidth + 'px';
  var body = document.createElement("body");
  var div = document.createElement("div");
  div.style.border = "1px solid transparent";
  document.querySelector('html').appendChild(body);
  body.appendChild(div);
  div.style.height = '100%';
  div.innerHTML = `<div class="preview_container">
    <iframe id="Iframe" src="${baseUrlPC}" frameborder="0" class="iframe iframeConatiner" seamless></iframe>
    </div>`
} else {
  document.querySelector('html').style.width = '100%';
  document.querySelector('html').classList.remove('pc');
}
// 兼容PC:如果是PC，会被嵌套进iframe里面 end

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')